import styled, { css } from 'styled-components';

interface CompanyStatus {
  opened: boolean;
}

export const Container = styled.header`
  width: 100%;
  /* height: 300px; */
  display: flex;
  flex-direction: column;
`;

export const ContainerBackground = styled.div`
  background-color: #d22011;
  background-size: 100% !important;
  height: 150px;
`;

export const ContainerInfo = styled.div`
  background-color: transparent;
  flex-grow: 1;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  position: relative;
  top: -50px;
  height: 170px;
`;

export const Logo = styled.img`
  width: 180px;
  object-fit: contain;
  margin-bottom: 16px;
  border-radius: 16px;
`;

export const CompanyName = styled.h4`
  text-align: center;
  color: #000;
`;

export const CompanyDescription = styled.p`
  text-align: center;
  color: #000;
`;

export const ContainerCompanyStatus = styled.div`
  display: flex;
  justify-content: center;
  /* margin-top: -24px; */
`;

export const CompanyStatus = styled.div<CompanyStatus>`
  color: #fff;
  background-color: #bf1021;
  border-color: #bf1021;
  font-weight: bold;
  font-size: 12px;
  text-transform: uppercase;
  padding: 8px 16px;
  border-radius: 0.25rem;
  border: 1px solid transparent;

  ${props =>
    props.opened &&
    css`
      background-color: #20c997;
      border-color: #20c997;
    `}
`;

export const SignOut = styled.div`
  position: absolute;
  top: 14px;
  left: 10px;
  background: #bf1021;
  color: #fff;
  padding: 4px 8px;
  border-radius: 6px;

  display: flex;
  align-items: center;
`;
